<template>
  <Container>
    <v-flex>
      <v-card>
        <v-toolbar dark>
          <v-btn
            icon
            color="white"
            light
            v-on:click="$router.push('/mini_games')"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>Cooking Game Manager</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="success" light v-on:click="showModalCreate()">
            <v-icon>add</v-icon>Add Cooking Game
          </v-btn>
          <v-text-field
            solo
            placeholder="Search"
            append-icon="search"
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <v-list-tile
              v-for="category in cookingGameList"
              :key="category._id"
              @click="onClickSelect(category._id)"
            >
              <v-list-tile-avatar>
                <v-icon>import_contacts</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ category.category }} ({{
                    category.number_of_game
                  }})</v-list-tile-title
                >
                <v-list-tile-sub-title
                  >Updated at {{ category.updated_at }}</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
    <ModalCreateUpdate
      :isOpen="isShowModal"
      :isCreate="isCreate"
      @close="isShowModal = false"
    ></ModalCreateUpdate>
  </Container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Container from '../../../components/Container';
import { ModalCreateUpdate } from './components';

export default {
  name: 'CookingGameCategory',
  components: {
    Container,
    ModalCreateUpdate,
  },
  computed: {
    ...mapState({
      stateKrub: state => state,
      cookingGameStore: state => state.cooking_game,
      cookingGameList: state => state.cooking_game.cookingGameList,
      selectedCookingGame: state => state.cooking_game.selectedCookingGame,
      isLoadCookingGame: state => state.cooking_game.isLoadCookingGame,
      defaultCreate: state => state.cooking_game.defaultCreate,
    }),
  },
  data: function() {
    return {
      search: '',
      isCreate: false,
      isShowModal: false,
    };
  },
  methods: {
    ...mapActions('category', ['fetchCategory']),
    ...mapActions('cooking_game', [
      'fetchCookingGameCategory',
      'setStateByKey',
      'createCookingGame',
    ]),
    showModalCreate() {
      this.isShowModal = true;
      this.isCreate = true;
      this.setStateByKey({
        statekey: 'createCookingGame',
        value: this.defaultCreate,
      });
    },
    onClickSelect(game_list_id) {
      this.$router.push({
        path: '/cooking_game/detail',
        query: {
          game_list_id,
        },
      });
    },
  },
  async mounted() {
    await this.fetchCookingGameCategory({ page: 1, limit: 0 });
  },
};
</script>
